// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t345 · LO QUE HAY ABIERTO AHORA EN UNA VENTANA (para el asistente LucIA, 21-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  La ficha de un paciente y el día de la agenda van en la dirección (/pacientes?paciente=…, /agenda?fecha=…); una CITA o un
//  PRESUPUESTO abiertos en su ventana, no. Esa ventana lo apunta aquí al abrirse y lo quita al cerrarse
//  (`useAbiertoEnPantalla('cita', id)`), y el panel de LucIA lo lee (components/asistenteLucia/PanelAsistenteLucia.jsx) para
//  mandarle al servidor SOLO el id, que el servidor comprueba con la clínica y los permisos
//  (backend/services/asistenteLuciaContexto.js). Nada más: ni datos del paciente, ni nada que salga de este navegador.
//  Sin dependencias más allá de react: lo cargan las guardias de verdad.
import { useEffect } from 'react'

const TIPOS = ['cita', 'presupuesto']
let abierto = { cita: null, presupuesto: null }
const oyentes = new Set()
const avisar = () => { for (const f of [...oyentes]) { try { f() } catch (_) { /* un oyente roto no para a los demás */ } } }
const entero = (v) => { const n = Number(v); return Number.isInteger(n) && n > 0 ? n : null }

export function marcarAbierto(tipo, id) {
  if (!TIPOS.includes(tipo)) return () => {}
  const n = entero(id)
  if (!n) return () => {}
  abierto = { ...abierto, [tipo]: n }
  avisar()
  // Al cerrarse, se quita (si no se ha abierto otra del mismo tipo entretanto).
  return () => { if (abierto[tipo] === n) { abierto = { ...abierto, [tipo]: null }; avisar() } }
}
export function abiertoAhora() { return abierto }
export function suscribirAbierto(fn) { oyentes.add(fn); return () => { oyentes.delete(fn) } }
// En la ventana que lo enseña: `useAbiertoEnPantalla('cita', cita && cita.id)`.
export function useAbiertoEnPantalla(tipo, id) {
  useEffect(() => marcarAbierto(tipo, id), [tipo, id])
}
